import { Component, Input, Output, EventEmitter, ElementRef, ViewChild } from '@angular/core';
import { forkJoin } from 'rxjs';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { StateService, AuthService } from '../../../services';
import { FilterItemValue } from '../../../models';
import { AuctionLotSearchFilterItemRangeModel } from '../../models';
import { FormFunctions } from '../../../functions';
import { Validations } from '../../../constants'
import { Options } from '@angular-slider/ngx-slider';

@Component({
    selector: 'search-filter-item-range',
    templateUrl: 'search-filter-item-range.component.html'
})
export class SearchFilterItemRangeComponent {
    processing: boolean = false;
    error: boolean = false;
    errorMessage: string = "";

    @Input() model: AuctionLotSearchFilterItemRangeModel;
    @Input() modalMode: boolean = true;

    options: Options;

    @Output() apply: EventEmitter<{ minValue: number, maxValue: number }> = new EventEmitter();
    @Output() close: EventEmitter<any> = new EventEmitter();

    @ViewChild("minValue") txtMinValue: ElementRef;
    @ViewChild("maxValue") txtMaxValue: ElementRef;

    constructor(public stateService: StateService, public validations: Validations, public formFunctions: FormFunctions, public authService: AuthService) {
        let me = this;

        me.options = <Options>{
            floor: this.model?.floor || 0,
            ceil: this.model?.ceiling || 999,
            translate: (value: number): string => {
                return this.model.prefix + value;
            }
        };
    }
    ngOnInit() {
        let me = this;
        setTimeout(() => { me.txtMinValue?.nativeElement.select(); }, 0); // focus on the text box when the modal opens
    }
    Save(form) {
        var me = this;
        me.apply.emit({ minValue: me.model.minValue <= 0 ? null : me.model.minValue, maxValue: me.model.maxValue <= 0 ? null : me.model.maxValue });
    }
    Close(evt) {
        var me = this;
        me.close.emit(null);
    }

}